import { FC, ReactElement } from 'react'

interface ConditionalRenderProps {
  condition: boolean
  wrapper: (el: ReactElement) => ReactElement
  children: ReactElement
}

const ConditionalRender: FC<ConditionalRenderProps> = ({
  condition,
  wrapper,
  children,
}): ReactElement => (condition ? wrapper(children) : children)

export default ConditionalRender
